import request from "superagent";
import { handleApiError } from "../utils/errors";
import { getAuthHeader } from "../utils/superagent";

export const getMetropolitanStatisticalAreas = async () => {
  const res = await request
    .get(`${global.api}/msa`)
    .set(await getAuthHeader())
    .query({ projection: ["name"] });
  return res.body;
};

export const getMSAByCoordinates = async (latitude, longitude, postalCode?: string) => {
  const res = await request
    .get(`${global.api}/msa/searchByCoordinates/${latitude},${longitude}?postalCode=${postalCode}`)
    .set(await getAuthHeader())
    .catch(handleApiError);
  return res && res.body;
};
